'use client'

import * as UI from './products-list.styled'

export const ProductsList = ({children}: React.PropsWithChildren) => {
  return <UI.ProductList>{children}</UI.ProductList>
}
